import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  IconButton,
  Paper,
  Card,
  Collapse,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from '@mui/material';
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  RemoveRedEyeOutlined,
  WorkOutline,
} from '@mui/icons-material';
import { TechnicianCard } from './components/TechnicianCard';
import { ProfessionalDetailsCard } from './components/ProfessionalCard';
import { useNavigate, useParams } from 'react-router-dom';
import {
  IBooking,
  ITechnician,
  IToolRequest,
} from '../../utils/entities/interface';
import {
  GetTechnician,
  TechnicianHistory,
} from '../../services/technician';
import withComponentAuth from '../../hoc/withComponentAuth';
import {
  capitalizeWords,
  formatDate,
  getStatusColor,
} from '../../utils/helper';
import { TechnicianTools } from '../../services/tool';
import useSnackbar from '../../hooks/useSnackbar';
import { DetailPageHeader } from '../../components/layout/DetailPageHeader';
import { APP_SHELL_HEADER_CONTROL_HEIGHT } from '../../components/layout/layoutConstants';

import AssignHelperModal from '../ACD_helper/AssignHelperModal';
import { AttendanceCalendar } from './components/AttendanceCalendar';
import { UnpairedTech } from '../../services/acdHelper';
import RequestToolModal from './components/RequestToolModal';

const TechnicianDetail = () => {
  const { technicianId } = useParams();
  const [technician, setTechnician] = useState<ITechnician | null>(null);
  const [address, setAddress] = useState<any>(null);
  const [assignModal, setAssignModal] = useState<boolean>(false);
  const { showSnackbar, SnackbarComponent } = useSnackbar();

  console.log(technicianId, '----0000000----');

  useEffect(() => {
    if (technicianId) fetchTechnician(technicianId);
  }, [technicianId]);

  const fetchTechnician = async (id: string) => {
    try {
      const result = await GetTechnician(id);
      setTechnician(result.technician);
      setAddress(result.address);
    } catch (error) {
      const message =
        error instanceof Error ? error.message : 'Failed to load technician';
      if (!/invalid|expired|token/i.test(message)) {
        showSnackbar(message, 'error');
      }
    }
  };

  const refreshTechnician = () => {
    if (technicianId) fetchTechnician(technicianId);
  };

  async function unPairHandle(id: string) {
    await UnpairedTech(id).then((response) => {
      if (response == 200) {
        refreshTechnician();
      } else {
        showSnackbar('Assignment Failed!', 'error');
      }
    });
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {SnackbarComponent}

      <DetailPageHeader
        title="View Technician"
        actions={
          technician?.status ? (
            <Chip
              label={technician.status.replace('_', ' ')}
              color={getStatusColor(technician.status)}
              size="small"
              sx={{
                fontWeight: 'bold',
                fontSize: '0.75rem',
                height: APP_SHELL_HEADER_CONTROL_HEIGHT,
                textTransform: 'capitalize',
              }}
            />
          ) : null
        }
      />

      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            backgroundColor: '#1C1C1C',
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            padding: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" color={'#FFFFFF'}>
            {technician?.name}
          </Typography>

          {technician?.position !== 'TBA' &&
          technician?.position !== 'HELPER' ? (
            <Button
              onClick={() => {
                if (technician?.isPaired) {
                  unPairHandle(technicianId || '');
                } else {
                  setAssignModal(true);
                }
              }}
              variant="outlined"
              size="small"
              color={technician?.isPaired ? 'success' : 'warning'}
              sx={{
                textTransform: 'none',
                fontSize: '0.8rem',
                borderRadius: '8px',
              }}
            >
              {technician?.isPaired ? 'Paired' : 'Pair'}
            </Button>
          ) : null}
        </Box>

        <Box
          display="flex"
          gap={2}
          sx={{ backgroundColor: '#1C1C1C', paddingX: 0 }}
        >
          <TechnicianCard
            address={address}
            technician={technician}
            onRefresh={refreshTechnician}
          />

          <ProfessionalDetailsCard
            position={technician?.position as string}
            experience={technician?.experience as string}
            technicianId={technicianId}
            ProfessionalSkills={technician?.professionalSkills}
            technician={technician ? technician : null}
            onRefresh={refreshTechnician}
          />
        </Box>

        <FeatureSection technician={technician} />

        <TechnicianHistoryComp userId={technician?._id ? technician._id : ''} />
      </Box>

      <AssignHelperModal
        isOpen={assignModal}
        onClose={() => setAssignModal(false)}
        bookingId={technicianId ? technicianId : ''}
        onReload={refreshTechnician}
      />
    </Box>
  );
};

export default withComponentAuth(TechnicianDetail);

export const TechnicianHistoryComp = ({ userId }: { userId: string }) => {
  const [history, setHistory] = useState<IBooking[] | null>(null);
  console.log(history, 'pppppppp');
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      FetchUserBookings(userId);
    }
  }, [userId]);

  const FetchUserBookings = async (userId: string) => {
    const bookings = await TechnicianHistory(userId);
    setHistory(bookings);
  };

  const getServiceNames = (row: any) => {
    if (Array.isArray(row?.services) && row.services.length > 0) {
      const serviceNames = row.services
        .map((service: any) => service?.serviceName)
        .filter(Boolean)
        .join(', ');

      return serviceNames || 'N/A';
    }

    return row?.service?.name || 'N/A';
  };

  const cellStyle: React.CSSProperties = {
    padding: '8px 0',
    fontSize: 15,
    color: '#F6F6F6',
    textAlign: 'center',
    border: 'none',
  };

  return (
    <div
      style={{
        background: '#181818',
        borderEndStartRadius: 18,
        borderEndEndRadius: 18,
        color: '#F6F6F6',
        fontFamily: 'Inter, Arial, sans-serif',
        boxShadow: '0 2px 24px #00000044',
        paddingTop: 10,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          marginBottom: 2,
          letterSpacing: 0.2,
          padding: '20px 14px 14px 14px',
          color: '#FFFFFF',
        }}
      >
        Booking History
      </Typography>

      <div style={{ height: 10 }} />

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr
            style={{
              background: '#232323',
              color: '#D6D6D6',
              fontSize: 13,
              fontWeight: 500,
              textAlign: 'center',
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
            }}
          >
            <th style={{ padding: '10px 0', borderTopLeftRadius: 8 }}>
              Booking ID
            </th>
            <th style={{ padding: '10px 0' }}>Customer</th>
            <th style={{ padding: '10px 0' }}>Service</th>
            <th style={{ padding: '10px 0' }}>Date</th>
            <th style={{ padding: '10px 0' }}>Slot</th>
            <th style={{ padding: '10px 0', borderTopRightRadius: 8 }}>View</th>
          </tr>
        </thead>

        <tbody>
          {Array.isArray(history) && history.length > 0 ? (
            history.map((row, i) => (
              <React.Fragment key={i}>
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      height: 8,
                      background: 'transparent',
                      padding: 0,
                      border: 'none',
                    }}
                  />
                </tr>

                <tr
                  style={{
                    background: '#181818',
                    borderTop: '1px solid #232323',
                    borderBottom: '1px solid #232323',
                  }}
                >
                  <td style={cellStyle}>{row.bookingId}</td>

                  <td style={cellStyle}>{row?.userName || 'N/A'}</td>

                  <td style={cellStyle}>{getServiceNames(row)}</td>

                  <td style={cellStyle}>{formatDate(row.date)}</td>

                  <td style={cellStyle}>
                    {capitalizeWords(row.slot).replace('_', ' ')}
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    <IconButton
                      sx={{ color: '#E31E25', textAlign: 'center' }}
                      onClick={() => navigate(`/technician/history/${row._id}`)}
                    >
                      <RemoveRedEyeOutlined />
                    </IconButton>
                  </td>
                </tr>
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td
                colSpan={6}
                style={{
                  textAlign: 'center',
                  padding: '20px',
                  color: '#888',
                  fontSize: '14px',
                  background: '#181818',
                  borderTop: '1px solid #232323',
                }}
              >
                No technician history found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div style={{ height: 12 }} />
    </div>
  );
};

const FeatureSection = ({ technician }: { technician: ITechnician | null }) => {
  return (
    <Box
      display="flex"
      gap={2}
      sx={{
        backgroundColor: '#1C1C1C',
        paddingX: 0,
        pt: 2,
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ flex: 1 }}>
        {technician?.type != 'FC' && (
          <RequestToolbag technicianId={technician?._id || ''} />
        )}
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <AttendanceCalendar technicianId={technician?._id || ''} />
      </Box>
    </Box>
  );
};

const RequestToolbag = ({
  technicianId,
  onRequested,
}: {
  technicianId: string;
  onRequested?: () => void;
}) => {
  const [toolList, setToolList] = useState<IToolRequest[]>([]);
  const [loading, setLoading] = useState(false);
  const [requestModal, setrequestModal] = useState(false);
  const { SnackbarComponent, showSnackbar, resetSnackbar } = useSnackbar();

  const getTechnicianTools = async () => {
    setLoading(true);

    try {
      const data = await TechnicianTools({ technicianId });

      if (data?.length > 0) {
        setToolList(data);
      } else {
        setToolList([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    technicianId && getTechnicianTools();
  }, [technicianId]);

  return (
    <Card
      sx={{
        backgroundColor: '#1C1C1C',
        color: 'white',
        borderRadius: 2,
        maxHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
        }}
      >
        {SnackbarComponent}

        <Typography variant="h6" fontWeight={600}>
          Tools
        </Typography>

        <Button
          onClick={() => {
            setrequestModal(true);
          }}
          variant="contained"
          startIcon={<WorkOutline />}
          disabled={!technicianId || loading}
          size="small"
          sx={{
            backgroundColor: '#d32f2f',
            '&:hover': { backgroundColor: '#b71c1c' },
            color: 'white',
            fontWeight: 700,
            textTransform: 'none',
            borderRadius: 2,
            px: 2,
            height: 36,
          }}
        >
          Assign Tools
        </Button>
      </Box>

      {toolList && toolList.length > 0 && (
        <Box sx={{ overflowY: 'auto', px: 2, pb: 2 }}>
          <ToolViewer toolbags={toolList} />
        </Box>
      )}

      {requestModal && (
        <RequestToolModal
          open={requestModal}
          onClose={() => setrequestModal(false)}
          onSave={() => {
            getTechnicianTools();
            setrequestModal(false);
          }}
          technicianId={technicianId}
        />
      )}
    </Card>
  );
};


const ToolViewer = ({ toolbags }: { toolbags: IToolRequest[] }) => {
  const Row = ({ row }: { row: IToolRequest }) => {
    const [open, setOpen] = useState(false);

    console.log('row', row);

    return (
      <>
        <TableRow>
          <TableCell sx={{ textAlign: 'left' }} component="th" scope="row">
            {row?.name || 'N/A'}
          </TableCell>

          <TableCell sx={{ textAlign: 'left' }}>{row?.total_qty}</TableCell>

          <TableCell sx={{ textAlign: 'left' }}>
            <IconButton size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, textAlign: 'left' }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ textAlign: 'left' }}>
                        Identifier
                      </TableCell>
                      <TableCell sx={{ textAlign: 'left' }}>Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {row &&
                      row.assigned_tools &&
                      row.assigned_tools.map((tool: any, idx: any) => (
                        <TableRow key={idx}>
                          <TableCell sx={{ textAlign: 'left' }}>
                            {tool.identifier}
                          </TableCell>

                          <TableCell sx={{ textAlign: 'left' }}>
                            {tool?.status?.replaceAll('_', ' ') || 'N/A'}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 1,
        width: '100%',
        maxHeight: '70%',
        overflowY: 'auto',
      }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ textAlign: 'left' }}>Tool Name</TableCell>
              <TableCell sx={{ textAlign: 'left' }}>Tool Quantity</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {toolbags.map((bag, index) => (
              <Row key={index} row={bag} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
